import { Permission } from "./Permission";

export class PermissionMatrix {
  Permission: Permission;
  IsSelected: boolean;
  constructor(permission: Permission, isSelected: boolean) {
    this.Permission = permission;
    this.IsSelected = isSelected;
  }
}
